export default __webpack_public_path__ + "static/media/questions-xs.06bb9f03.png";